export default __webpack_public_path__ + "static/media/FILTER_ICON1.0a2e1ac0.svg";